export default "__VITE_ASSET__4NatwSiW__"